import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// AI Module specific slices
import aiAssistantSlice from './slices/aiAssistantSlice';
import aiConversationSlice from './slices/aiConversationSlice';
import aiAnalyticsSlice from './slices/aiAnalyticsSlice';
import aiKnowledgeSlice from './slices/aiKnowledgeSlice';

export const aiStore = configureStore({
  reducer: {
    aiAssistants: aiAssistantSlice,
    aiConversations: aiConversationSlice,
    aiAnalytics: aiAnalyticsSlice,
    aiKnowledge: aiKnowledgeSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type AIRootState = ReturnType<typeof aiStore.getState>;
export type AIAppDispatch = typeof aiStore.dispatch;

// Typed hooks for AI module
export const useAIDispatch = () => useDispatch<AIAppDispatch>();
export const useAISelector: TypedUseSelectorHook<AIRootState> = useSelector;